import type { ITextElement } from '@chainlit/react-client';

interface Props {
    items: ITextElement[];
}

// "Sources used" text elements are surfaced exclusively via DMSourceBadge hover cards.
// Nothing is rendered here — the inline elements are consumed by the badge context only.
const InlinedTextList = (_props: Props) => null;

export { InlinedTextList };
